var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 403,
    height: 317,
    viewBox: "0 0 403 317",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.549 161.636H182.348",
    stroke: "#EE781D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.549 167.047H182.348",
    stroke: "#EE781D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.549 172.457H182.348",
    stroke: "#EE781D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.479 68.2251H147.278",
    stroke: "#0090B7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.479 73.6355H147.278",
    stroke: "#0090B7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.479 79.0464H147.278",
    stroke: "#0090B7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M297.751 155.017H316.55",
    stroke: "#0090B7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M297.751 160.427H316.55",
    stroke: "#0090B7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M297.751 165.838H316.55",
    stroke: "#0090B7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.472 237.026H121.271",
    stroke: "#0090B7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.472 242.437H121.271",
    stroke: "#0090B7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102.472 247.848H121.271",
    stroke: "#0090B7",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M105.269 162.844C110.549 162.844 114.829 158.57 114.829 153.297C114.829 148.024 110.549 143.75 105.269 143.75C99.9885 143.75 95.7082 148.024 95.7082 153.297C95.7082 158.57 99.9885 162.844 105.269 162.844Z",
    fill: "#0090B7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.663 138.948C110.413 138.948 112.643 136.721 112.643 133.975C112.643 131.228 110.413 129.002 107.663 129.002C104.913 129.002 102.683 131.228 102.683 133.975C102.683 136.721 104.913 138.948 107.663 138.948Z",
    fill: "#0090B7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M125.19 137.372C126.776 137.372 128.062 136.088 128.062 134.504C128.062 132.92 126.776 131.635 125.19 131.635C123.603 131.635 122.317 132.92 122.317 134.504C122.317 136.088 123.603 137.372 125.19 137.372Z",
    fill: "#0090B7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M126.895 157.299C130.698 157.299 133.781 154.22 133.781 150.422C133.781 146.624 130.698 143.545 126.895 143.545C123.092 143.545 120.008 146.624 120.008 150.422C120.008 154.22 123.092 157.299 126.895 157.299Z",
    fill: "#0090B7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M288.678 268.754C293.958 268.754 298.239 264.48 298.239 259.207C298.239 253.934 293.958 249.66 288.678 249.66C283.398 249.66 279.118 253.934 279.118 259.207C279.118 264.48 283.398 268.754 288.678 268.754Z",
    fill: "#0090B7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M275.309 250.009C278.059 250.009 280.289 247.783 280.289 245.036C280.289 242.29 278.059 240.063 275.309 240.063C272.559 240.063 270.329 242.29 270.329 245.036C270.329 247.783 272.559 250.009 275.309 250.009Z",
    fill: "#0090B7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M286.902 234.766C288.488 234.766 289.774 233.482 289.774 231.898C289.774 230.314 288.488 229.029 286.902 229.029C285.315 229.029 284.029 230.314 284.029 231.898C284.029 233.482 285.315 234.766 286.902 234.766Z",
    fill: "#0090B7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M300.262 247.622C304.066 247.622 307.149 244.543 307.149 240.745C307.149 236.947 304.066 233.868 300.262 233.868C296.459 233.868 293.376 236.947 293.376 240.745C293.376 244.543 296.459 247.622 300.262 247.622Z",
    fill: "#0090B7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M279.115 107.402C284.395 107.402 288.676 103.127 288.676 97.8545C288.676 92.5818 284.395 88.3074 279.115 88.3074C273.835 88.3074 269.555 92.5818 269.555 97.8545C269.555 103.127 273.835 107.402 279.115 107.402Z",
    fill: "#0090B7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M261.879 88.6566C264.63 88.6566 266.859 86.4301 266.859 83.6836C266.859 80.9372 264.63 78.7107 261.879 78.7107C259.129 78.7107 256.899 80.9372 256.899 83.6836C256.899 86.4301 259.129 88.6566 261.879 88.6566Z",
    fill: "#0090B7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M280.704 85.5864C284.507 85.5864 287.59 82.5075 287.59 78.7096C287.59 74.9117 284.507 71.8328 280.704 71.8328C276.901 71.8328 273.817 74.9117 273.817 78.7096C273.817 82.5075 276.901 85.5864 280.704 85.5864Z",
    fill: "#0090B7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M171.852 228.118C177.132 228.118 181.413 223.844 181.413 218.571C181.413 213.298 177.132 209.024 171.852 209.024C166.572 209.024 162.292 213.298 162.292 218.571C162.292 223.844 166.572 228.118 171.852 228.118Z",
    fill: "#EE781D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M158.483 209.373C161.233 209.373 163.462 207.146 163.462 204.4C163.462 201.653 161.233 199.427 158.483 199.427C155.732 199.427 153.503 201.653 153.503 204.4C153.503 207.146 155.732 209.373 158.483 209.373Z",
    fill: "#EE781D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M170.075 194.13C171.662 194.13 172.948 192.846 172.948 191.262C172.948 189.678 171.662 188.393 170.075 188.393C168.489 188.393 167.203 189.678 167.203 191.262C167.203 192.846 168.489 194.13 170.075 194.13Z",
    fill: "#EE781D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M183.436 206.986C187.239 206.986 190.322 203.907 190.322 200.109C190.322 196.311 187.239 193.232 183.436 193.232C179.632 193.232 176.549 196.311 176.549 200.109C176.549 203.907 179.632 206.986 183.436 206.986Z",
    fill: "#EE781D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M195.435 95.2729C214.982 67.766 227.117 42.8373 222.539 39.5931L217.294 35.8762C212.716 32.6319 193.159 52.3008 173.612 79.8077C154.064 107.314 141.929 132.243 146.507 135.487L151.752 139.204C156.33 142.448 175.887 122.78 195.435 95.2729Z",
    fill: "#E06714"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M190.19 91.5559C209.737 64.0491 221.872 39.1204 217.294 35.8762C212.716 32.6319 193.158 52.3007 173.611 79.8076C154.064 107.314 141.93 132.243 146.508 135.487C151.086 138.731 170.643 119.063 190.19 91.5559Z",
    fill: "#EE781D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M185.826 71.0235C191.264 74.8773 175.246 97.418 169.808 93.5642C164.369 89.7105 163.547 81.5405 167.97 75.316C172.393 69.0915 180.388 67.1697 185.826 71.0235Z",
    fill: "#E06714"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M147.278 156.396L161.634 281.809H161.79C161.79 286.085 182.674 289.551 208.435 289.551C234.196 289.551 255.08 286.085 255.08 281.809H255.236L269.592 156.396H147.278Z",
    fill: "#EE781D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M208.435 166.546C242.211 166.546 269.591 162.002 269.591 156.396C269.591 150.79 242.211 146.246 208.435 146.246C174.659 146.246 147.278 150.79 147.278 156.396C147.278 162.002 174.659 166.546 208.435 166.546Z",
    fill: "#E06714"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M211.539 184.563H208.794C208.109 184.563 207.554 185.118 207.554 185.802V274.424C207.554 275.107 208.109 275.662 208.794 275.662H211.539C212.224 275.662 212.779 275.107 212.779 274.424V185.802C212.779 185.118 212.224 184.563 211.539 184.563Z",
    fill: "#E06714"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M238.031 275.783L234.728 275.327C234.2 275.254 233.802 274.335 233.838 273.273L236.804 186.233C236.84 185.171 237.297 184.369 237.824 184.442L241.128 184.898C241.655 184.971 242.053 185.891 242.017 186.952L239.052 273.993C239.015 275.055 238.559 275.856 238.031 275.783ZM180.4 275.783L183.703 275.327C184.231 275.254 184.629 274.335 184.593 273.273L181.627 186.233C181.591 185.171 181.134 184.369 180.607 184.442L177.303 184.898C176.776 184.971 176.378 185.891 176.414 186.952L179.379 273.993C179.415 275.055 179.872 275.856 180.4 275.783Z",
    fill: "#E06714"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M235.289 140.34L230.986 154.908L193.792 143.953C193.594 143.895 193.41 143.798 193.249 143.669C193.089 143.539 192.956 143.38 192.857 143.199C192.758 143.018 192.696 142.819 192.674 142.614C192.653 142.409 192.671 142.202 192.73 142.004L210.136 83.0707C210.195 82.8731 210.292 82.6889 210.421 82.5286C210.551 82.3683 210.711 82.2351 210.892 82.1366C211.073 82.038 211.272 81.9761 211.477 81.9543C211.683 81.9326 211.89 81.9514 212.088 82.0097L262.423 96.8354C262.621 96.8937 262.805 96.9903 262.966 97.1198C263.126 97.2493 263.26 97.4091 263.358 97.5901C263.457 97.771 263.519 97.9696 263.541 98.1745C263.563 98.3794 263.544 98.5866 263.485 98.7842L249.937 144.655L235.289 140.34Z",
    fill: "#F9AE2B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M230.986 154.908L235.289 140.341L249.937 144.655L230.986 154.908Z",
    fill: "#3086A3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M233.937 100.657L215.4 95.1975L212.905 103.648L231.441 109.108L233.937 100.657Z",
    fill: "#3086A3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M237.301 106.24L251.497 110.422",
    stroke: "#3086A3",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M204.711 132.054L218.908 136.235",
    stroke: "#3086A3",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M210.958 110.239L248.303 121.239",
    stroke: "#3086A3",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M208.815 117.493L246.16 128.493",
    stroke: "#3086A3",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M206.673 124.747L244.017 135.747",
    stroke: "#3086A3",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTrash);
export default __webpack_public_path__ + "static/media/emptyTrash.c85ab92a723f551f1f4f94c76616fda4.svg";
export { ForwardRef as ReactComponent };